import Request from './request'

const Simcard = {
  getPagesSimcards (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard/pages', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardList (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard/list/' + params.page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardHistoryAction(params, callback) {
    Request.post('simcard/logs', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardProfile(id, callback) {
    Request.get('simcard/view/'+ id).then(callback).catch(this.bad_answer)
  },
  getSimcardTraffic (id, tsStart, tsEnd, callback) {
    Request.get('simcard/traffic/' + id + '?start=' + tsStart + '&end=' + tsEnd).then(callback).catch(this.bad_answer)
  },
  getSimcardDeviceHistory(id, callback) {
    Request.get('simcard/device-history/' + id).then(callback).catch(this.bad_answer)
  },
  putSimcardDevices(id, params, callback) {
    Request.put('simcard/update/'+ id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Simcard
